import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      datePicker: {
        title: '📅 Select Your Travel Dates',
        from: 'FROM',
        to: 'TO',
        placeholder: 'YYYY/MM/DD',
        cancel: 'Cancel',
        confirm: 'Confirm Dates',
      },
    },
  },
  ta: {
    translation: {
      datePicker: {
        title: '📅 உங்கள் பயண தேதிகளை தேர்ந்தெடுக்கவும்',
        from: 'தொடக்கம்',
        to: 'முடிவு',
        placeholder: 'YYYY/MM/DD',
        cancel: 'ரத்து செய்',
        confirm: 'தேதிகளை உறுதிப்படுத்து',
      },
    },
  },
  hi: {
    translation: {
      datePicker: {
        title: '📅 अपनी यात्रा तिथियाँ चुनें',
        from: 'से',
        to: 'तक',
        placeholder: 'YYYY/MM/DD',
        cancel: 'रद्द करें',
        confirm: 'तिथियाँ पुष्टि करें',
      },
    },
  },
  te: {
    translation: {
      datePicker: {
        title: '📅 మీ ప్రయాణ తేదీలను ఎంచుకోండి',
        from: 'నుండి',
        to: 'వరకు',
        placeholder: 'YYYY/MM/DD',
        cancel: 'రద్దు చేయి',
        confirm: 'తేదీలను నిర్ధారించండి',
      },
    },
  },
  ml: {
    translation: {
      datePicker: {
        title: '📅 നിങ്ങളുടെ യാത്ര തീയതികൾ തിരഞ്ഞെടുക്കുക',
        from: 'മുതൽ',
        to: 'വരെ',
        placeholder: 'YYYY/MM/DD',
        cancel: 'റദ്ദാക്കുക',
        confirm: 'തീയതികൾ സ്ഥിരീകരിക്കുക',
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',          
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;
